import { render, staticRenderFns } from "./headerBarNotification.vue?vue&type=template&id=74e2f662"
import script from "./headerBarNotification.vue?vue&type=script&lang=js"
export * from "./headerBarNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports